import styled, { css } from 'styled-components';
import { mediaMixin } from '@zillow/constellation';

export const UpsellModule = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const Content = styled.div`
  margin: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  ${mediaMixin(
    'lg',
    css`
      flex-direction: row;
    `,
  )};
`;

export const SectionA = styled.div`
  width: 100%;
  margin: 0;
  margin-bottom: 24px;
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.35);

  > img {
    max-width: 100%;
    max-height: 100%;
  }

  ${mediaMixin(
    'lg',
    css`
      width: 50%;
      margin-right: 40px;
    `,
  )};
`;

export const SectionB = styled.div`
  width: 100%;

  ${mediaMixin(
    'lg',
    css`
      width: 50%;
    `,
  )};
`;

export const Copy = styled.div`
  margin-bottom: 24px;

  ${mediaMixin(
    'lg',
    css`
      margin-bottom: 0;
    `,
  )};
`;

export const BenefitContent = styled.div`
  h3 {
    text-align: center;
  }
`;
